import React from 'react';

function PreLoader() {
    return <div className={'site-preloader active'} />;
}

export default PreLoader;
